import React, { CSSProperties, FunctionComponent } from 'react'

const style: CSSProperties = { flex: '1 1 auto', margin: 0 }

const Spacer: FunctionComponent = () => <div style={style}/>

export default Spacer